import { useI18n } from '../../i18n'
import EditEntryModal from './EditEntryModal'
import DateTimeField from '../ui/DateTimeField'
import {
   closeEditHistoryModal,
   deleteEditedHistoryEntry,
   editingHistoryEndValue,
   editingHistoryStartValue,
   historyEditError,
   isEditHistoryModalOpen,
   saveEditedHistoryEntry,
   setEditingHistoryEndInputValue,
   setEditingHistoryStartInputValue,
} from '../../state/currentFastStore'

/**
 * Renders the fast-history edit modal.
 *
 * @returns The modal element.
 */
const EditModal = () => {
   const t = useI18n()

   return (
      <EditEntryModal
         id="edit-modal"
         open={isEditHistoryModalOpen()}
         title={t('Edit Fast')}
         error={historyEditError()}
         saveId="save-edit-btn"
         cancelId="cancel-edit-btn"
         onSave={saveEditedHistoryEntry}
         onCancel={closeEditHistoryModal}
         onDelete={deleteEditedHistoryEntry}
         deleteId="delete-edit-btn"
      >
         <DateTimeField
            id="edit-start-time"
            label={t('Start Time')}
            value={editingHistoryStartValue()}
            onValueInput={setEditingHistoryStartInputValue}
            noFuture={false}
         />
         <DateTimeField
            id="edit-end-time"
            label={t('End Time')}
            value={editingHistoryEndValue()}
            onValueInput={setEditingHistoryEndInputValue}
            noFuture={false}
         />
      </EditEntryModal>
   )
}

export default EditModal
